import RenderHTML from './RenderHTML';

export default RenderHTML;
